<template>
  <div class="graph-distribution-area">
    <div class="graph-distribution-area__income-graph">
      <pull-down-button :text="incomeGraphText" :width="widthOfGraph" ref="button1">
        <income-graph :data="incomeData"/>
      </pull-down-button>
    </div>
    <div class="graph-distribution-area__age-market-breakers-graph">
      <pull-down-button :text="ageGraphText" :width="widthOfGraph" ref="button2">
        <age-market-breaker-graph :data="ageMarketBreakerData" :meanAge="meanAge"/>
      </pull-down-button>
    </div>
    <div class="graph-distribution-area__age-distribution-graph">
      <pull-down-button :text="ageDistributionText" :width="widthOfGraph" ref="button3">
        <age-distribution-graph :data="ageData" :meanAge="meanAge"/>
      </pull-down-button>
    </div>
  </div>
</template>

<script>
import AgeMarketBreakerGraph from '@/appComponents/graphs/AgeMarketBreakerGraph'
import AgeDistributionGraph from '@/appComponents/graphs/AgeDistributionGraph'
import IncomeGraph from '@/appComponents/graphs/IncomeGraph'
import PullDownButton from '@/components/common/pullDownButton'

export default {
  components: {
    AgeMarketBreakerGraph,
    AgeDistributionGraph,
    IncomeGraph,
    PullDownButton
  },
  data () {
    return {
      incomeGraphText: 'Income',
      ageGraphText: 'Age Market Breaker',
      ageDistributionText: 'Age (10 years)',
      MAX_WIDTH_OF_GRAPH_AREA: 1200,
      DISTANCE_BETWEEN_BUTTONS: 25,
      widthOfGraph: 400
    }
  },
  computed: {
    ageData: function () {
      return this.$store.getters.ageDistribution
    },
    ageMarketBreakerData: function () {
      return this.$store.getters.ageBreakers
    },
    meanAge () {
      return this.$store.getters.ageMean
    },
    incomeData () {
      return this.$store.getters.incomeData
    }
  },
  methods: {
    recomputeWidthOfGraph (dontTryAgain) {
      // TODO get this inside a Utility class so that it can be used again... and reusable
      // TODO this needs to be in Mixin or in a slotted Component
      const NUMBER_OF_BUTTONS = 3   // the number of buttons to display
      const MARGIN_OFF_WALLS = 25  // margin off the walls
      const screenWidth = window.outerWidth
      let extendedArea = ((NUMBER_OF_BUTTONS - 1) * this.DISTANCE_BETWEEN_BUTTONS) + (2 * MARGIN_OFF_WALLS)
      let button1 = this.$refs.button1
      let button2 = this.$refs.button2
      let button3 = this.$refs.button3
      let listOfSizes = [button1.getButtonSize(), button2.getButtonSize(), button3.getButtonSize()]
      let distances = [MARGIN_OFF_WALLS]
      let last = MARGIN_OFF_WALLS
      for (let i = 0; i < listOfSizes.length - 1; i++) {
        let first = listOfSizes[i] / 2
        let second = listOfSizes[i + 1] / 2
        last = first + second + this.DISTANCE_BETWEEN_BUTTONS + last
        extendedArea += last
        distances.push(last)
      }
      button1.$el.style.left = distances[0] + 'px'
      button2.$el.style.left = distances[1] + 'px'
      button3.$el.style.left = distances[2] + 'px'
      const widthToWorkWith = screenWidth - extendedArea
      this.widthOfGraph = Math.min(widthToWorkWith, this.MAX_WIDTH_OF_GRAPH_AREA)
      if (!dontTryAgain) {
        setTimeout(() => this.recomputeWidthOfGraph(true), 10)
      }
    }
  },
  mounted () {
    this.recomputeWidthOfGraph()
    window.addEventListener('resize', this.recomputeWidthOfGraph)
  },
  destroyed () {
    window.removeEventListener('resize', this.recomputeWidthOfGraph)
  }
}
</script>

<style lang="scss">

.graph-distribution-area {
  &__canvas {
    max-height: 500px;
    box-sizing: border-box;
    @if ($z-graph-distribution-area) {
      z-index: $z-graph-distribution-area;
    } @else {
      z-index: 109;
    }
    @include drop-shadow;
    background-color: white;
    padding: 0px 0px 0px 15px;
  }
}

.arrowPosition {
  position: relative;
  left: 10px;
  top: 4px;
}

.distributionButton {
  border-bottom-left-radius: 80px;
  border-bottom-right-radius: 80px;
  border: 1px solid #232a32;
  text-align: center;
  width: 120px;
  background-color: #232a32;
  color: white;
  padding-left: 20px;
  padding-bottom: 10px;
  padding-right: 20px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// DistributionGraphArea.vue?69c4993b